import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Pagination } from 'hljd'
import styles from './style.module.less'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { pagination, paginationChange } = this.props.store
    return (
      <div className={styles.pageWrap}>
        <Pagination
          {...pagination}
          onShowSizeChange={paginationChange}
          onChange={paginationChange}
        />
      </div>
    )
  }
}
